// ============================================================================
// HAI Reporting Tool - Infection Rate Chart
// Line chart for infection rate trends
// ============================================================================

import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

interface InfectionRateChartProps {
  data: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      borderColor: string;
      backgroundColor: string;
    }[];
  };
  title?: string;
}

export function InfectionRateChart({ data, title = 'Infection Rates Over Time' }: InfectionRateChartProps) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Rate per 1000 device-days'
        }
      }
    }
  };

  return (
    <div className="card">
      <Line options={options} data={data} />
    </div>
  );
}
